<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap justify-center>
            <v-flex xs12 sm6>
                <v-autocomplete
                        v-model="selectedUser"
                        :items="users.items"
                        :placeholder="$t('select_user')"
                        :label="$t('select_user')"
                        :disabled="loading"
                        item-text="selectText"
                        return-object
                        flat
                        hide-no-data
                        hide-details
                        @input="update"
                ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6>
                <v-autocomplete
                        v-model="selectedEvent"
                        :items="events.items"
                        :loading="!events.loaded"
                        :placeholder="$t('event')"
                        :label="$t('event')"
                        :disabled="loading"
                        item-text="name"
                        return-object
                        flat
                        hide-no-data
                        hide-details
                        @input="update"
                >
                    <template slot="selection" slot-scope="{ item }">
                        <span>{{ $formatDate(item.start) + ' - ' + item.name }}</span>
                    </template>
                    <template slot="item" slot-scope="data">
                        <span>{{ $formatDate(data.item.start) + ' - ' + data.item.name }}</span>
                    </template>
                </v-autocomplete>
            </v-flex>

            <v-flex xs12 sm6 v-if="eventRegistrations.loaded">
                <v-checkbox
                        class="mt-0"
                        :disabled="loading || eventRegistrations.items.length === 0"
                        v-model="createStarters"
                        label="Meldungen als offnene Meldungen wiederherstellen"
                ></v-checkbox>
            </v-flex>

            <v-flex xs12 sm6 v-if="eventRegistrations.loaded">
                <v-checkbox
                        class="mt-0"
                        :disabled="loading || eventRegistrations.items.length === 0"
                        v-model="sendRefundMail"
                        label="E-Mail an den Kunden versenden"
                ></v-checkbox>
            </v-flex>

            <v-flex xs12 v-if="eventRegistrations.loaded">
                <v-checkbox
                        class="mt-0"
                        :disabled="loading || eventRegistrations.items.length === 0"
                        v-model="createCancellation"
                        label="Stornorechnung erstellen"
                ></v-checkbox>
            </v-flex>

            <v-flex xs12 v-if="eventRegistrations.loaded">
                <v-btn
                        :disabled="loading || eventRegistrations.items.length === 0"
                        :loading="loading"
                        @click="refund"
                        block
                        outline
                >Meldungen stornieren</v-btn>
            </v-flex>

            <v-flex xs12 v-if="eventRegistrations.loaded && eventRegistrations.items.length > 0">
                <item-list
                        :filter="false"
                        :items="eventRegistrations.items"
                        :data-table-config="dataTableConfig"
                        header="Meldungen"
                ></item-list>
            </v-flex>

            <v-progress-circular
                    class="mt-2"
                    :size="150"
                    :width="1"
                    v-show="loading && !eventRegistrations.loaded"
                    indeterminate
                    color="primary"
            ></v-progress-circular>
        </v-layout>
    </v-container>
</template>

<script>
    import ItemList from '../../components/common/ItemList';
    import { mapState } from "vuex";

    export default {
        components: {
            ItemList
        },
        data() {
            return {
                loading: false,
                createStarters: true,
                sendRefundMail: true,
                createCancellation: true,
                selectedUser: null,
                selectedEvent: null,
                eventRegistrations: {
                    loaded: false,
                    items: []
                },
                dataTableConfig: {
                    headers: [
                        {text: 'Name', value: 'name', align: 'left'},
                        {text: 'Startertyp', value: 'starter_type.name', align: 'left'},
                        {text: 'Altersklasse', value: 'de', align: 'left'},
                    ],
                    items: {
                        large: [
                            {value: 'name'},
                            {value: 'starter_type.name', formatFunction: '$t'},
                            {value: 'age_group.name'},
                        ],
                        small: [
                            {value: 'name'},
                            {value: 'starter_type.name', formatFunction: '$t'},
                            {value: 'age_group.name'},
                        ]
                    }
                }
            }
        },
        computed: {
            ...mapState(['users', 'user', 'events'])
        },
        mounted() {
        },
        methods: {
            update() {
                if (this.selectedUser === null || this.selectedEvent === null || this.loading) {
                    return;
                }

                this.loading = true;
                this.eventRegistrations.loaded = false;

                axios.get('/api/v1/event_registrations', {
                    params: {
                        user_id: this.selectedUser.id,
                        event_id: this.selectedEvent.id
                    }
                }).then(response => {
                    if (!response.data.success) {
                        return;
                    }

                    this.$set(this.eventRegistrations, 'items', response.data.data);
                    this.$set(this.eventRegistrations, 'loaded', true);

                    this.loading = false;
                });
            },
            refund() {
                this.$store.commit('confirm', {
                    headline: 'Meldungen wirklich stornieren?',
                    text: 'Alle Meldungen zu diesem Turnier werden storniert.',
                    callback: () => {
                        this.loading = true;

                        axios.post('/api/v1/refunds', {
                            user_id: this.selectedUser.id,
                            event_id: this.selectedEvent.id,
                            create_starters: this.createStarters,
                            send_refund_mail:  this.sendRefundMail,
                            create_cancellation:  this.createCancellation
                        }).then(response => {
                            this.loading = false;
                            this.update();

                            this.$store.commit('snackBar', {
                                color: 'success',
                                text: 'Storno erfolgreich angelegt'
                            });
                        }, error => {
                            this.loading = false;
                        });
                    }
                });
            }
        }
    }
</script>
